<template>
  <div class="reviews-list">
    <Review
      v-for="review in reviews"
      :key="review.id"
      :review="review"
      class="card__block reviews__item"
    />

    <div v-if="!reviews.length" class="reviews-list__message">
      <span v-show="!isFiltered">
        {{ $t('APP.REVIEWS.NO_REVIEWS') }}
      </span>

      <span v-show="isFiltered">
        {{ $t('APP.REVIEWS.NO_REVIEWS_WITH_APPLIED_FILTER') }}
      </span>
    </div>
  </div>
</template>

<script>
import Review from './Review';

export default {
  name: 'ReviewsList',

  components: { Review },

  props: {
    reviews: {
      type: Array,
      default: () => [],
    },
    isFiltered: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.reviews-list {
  &__message {
    padding: $global-padding * 1.5;
  }
}
</style>
